export const hardcodedContent = {
	readMore: "Read more",
	all: "All",
	featuredNews: "Featured news",
	readMoreNews: "Read more news",
	discoverMore: "Discover more",
	mobileNavbar: {
		menu: "MENU",
		close: "CLOSE",
	},
	footerWhiteBlock: {
		letsConnect: "Let’s connect.",
		letsGrow: "Let’s grow.",
		letsMakeItHappenTogether: "Let’s make it happen together.",
		textAboveInput1: "Want to learn more?",
		textAboveInput2: "Get in touch with us at email.",
		enterEmail: "Enter your email",
		subscribe: "Subscribe",
		contact: "Contact",
		seeMore: "See more",
		follow: "Follow",
		subscribeSuccess: "Successfully subscribed to newsletter!",
		subscribeError: "Something went wrong. Please try again.",
	},
	ourProducts: {
		cta: "Explore more",
	},
	ourServices: {
		cta: "Explore more",
	},
	homePage: {
		moreAboutUs: "More about us",
		hero: {
			headline1: "Bridging borders",
			headline2: "building futures",
		},
		aboutCompanyPartOne: {
			headline: "At Rarraba, we’re",
			headlineLine2: "more than",
			headlineLineAnimationText: ["company", "business", "suppliers"],
		},
		aboutCompanyPartTwo: {
			headline: "Quality, reliability,",
			headlineLine2: "lasting growth",
		},
		aboutCompanyPartThree: {
			headline: "Together, we are",
			headlineLine2: "building",
			headlineLine3: "future",
		},
	},
	aboutPage: {
		hero: {
			headlineLine1: "We believe that business is more than just numbers.",
			headlineLine2: "It’s about",
			headlineLineAnimationText: ["people", "connections", "impact", "purpose"],
		},
	},
	productsAndServicesPage: {
		hero: {
			headlineLine1: "Empowering your business with tailored solutions",
			headlineLine2: "that drive",
			headlineLineAnimationText: ["growth", "efficiency", "sustainability", "innovation"],
		},
	},
	singleNewsPage: {
		tableOfContents: "Table of contents",
		authors: "Authors",
		share: "Share",
		references: "References",
		showMore: "Show more",
		showLess: "Show less",
	},
	contactPage: {
		formMessage: {
			topic: "Please select a topic",
			nameAndSurnamePlaceholder: "Name and surname",
			nameAndSurname: "Name and surname are required",
			nameAndSurnameMinLength: "Name must be at least 2 characters long",
			telephoneNumberPlaceholder: "Telephone number",
			telephoneNumber: "Telephone number is required",
			telephoneNumberInvalid: "Please enter a valid telephone number",
			emailPlaceholder: "E-mail",
			email: "E-mail is required",
			emailInvalid: "Please enter a valid email address",
			companyNamePlaceholder: "Company name",
			messagePlaceholder: "Your message...",
			message: "Message is required",
			messageMinLength: "Message must be at least 10 characters long",
			privacyPolicyInfo: "BY CLICKING THE SEND BUTTON YOU AGREE TO OUR",
			privacyPolicyTerms: "PRIVACY POLICY TERMS",
			acceptPrivacyPolicy: "You must accept the privacy policy",
			success: "Message sent successfully! We`ll get back to you soon.",
			error: "There was an error sending your message. Please try again.",
		},
		visitUs: {
			getDirections: "Get Directions",
		},
	},
	errorPage: {
		mainTitle: "Error 404",
		title: "We're sorry, but the page you're looking for doesn't exist",
		description: "Please use the navigation menu to find the page you're looking for. You can also return to the homepage.",
		cta: "Back to home",
	},
};
